import { ReactNode } from "react";
import { Link } from "react-router-dom";
import "./PageHeader.scss";

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  lead?: string;
  // Current page label for the "Home / …" breadcrumb.
  crumb?: string;
  children?: ReactNode;
}

const PageHeader = ({ eyebrow, title, lead, crumb, children }: PageHeaderProps) => (
  <section className="ss-page-header">
    <div className="ss-container">
      {crumb && (
        <nav aria-label="Breadcrumb" className="ss-page-header__crumbs">
          <Link to="/">Home</Link>
          <i className="bi bi-chevron-right" aria-hidden="true"></i>
          <span aria-current="page">{crumb}</span>
        </nav>
      )}
      {eyebrow && <span className="ss-eyebrow ss-page-header__eyebrow">{eyebrow}</span>}
      <h1>{title}</h1>
      {lead && <p className="ss-page-header__lead">{lead}</p>}
      {children}
    </div>
  </section>
);

export default PageHeader;
